<template>
  <div class="info-sale pl-4 pr-4">
    <div class="flex border-b-default pb-1 flex-wrap">
      <div class="my-2 w-50" v-if="canEdit('category')">
        <VSelect
          :items="categories"
          label="Tipo Ativação"
          id="category"
          name="category"
          v-model="editSale.category"
          v-validate="'required'"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <div :id="`category-${index}`" class="v-list__tile__title">{{ item.text }}</div>
            </div>
          </template>
        </VSelect>
      </div>
      <div class="my-2 w-50" v-if="canEdit('customerCpf')">
        <SmartInput
          label="CPF do Cliente"
          id="cpf"
          name="cpf"
          :mask="'###.###.###-##'"
          :error="errors.first('cpf')"
          v-model="editSale.customerCpf"
          v-validate="'cpf'"
        />
      </div>
      <div class="my-2 w-50" v-if="canEdit('imei')">
        <SmartInput
          label="IMEI"
          id="imei"
          name="imei"
          :mask="'#'.repeat(15)"
          :error="errors.first('imei')"
          v-model="editSale.imei"
          v-validate="'required|validateImei'"
        />
      </div>
      <div class="my-2 w-50" v-if="canEdit('brand')">
        <VSelect
          :items="brands"
          label="Marca"
          id="brand"
          item-text="name"
          item-value="id"
          name="brand"
          @change="fetchGadget(editSale.gadget.brand.id)"
          v-model="editSale.gadget.brand.id"
          v-validate="'required'"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <div :id="`brand-${index}`" class="v-list__tile__title">{{ item.name }}</div>
            </div>
          </template>
        </VSelect>
      </div>
      <div class="my-2 w-50" v-if="canEdit('gadget_category')">
        <VSelect
          :items="gadgetCategories"
          label="Categoria"
          id="gadget_category"
          item-text="name"
          item-value="id"
          name="gadget_category"
          @change="fetchGadgetByCategory(editSale.gadget.gadget_category.id)"
          v-model="editSale.gadget.gadget_category.id"
          v-validate="'required'"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <div :id="`gadget-category-${index}`" class="v-list__tile__title">
                {{ item.name }}
              </div>
            </div>
          </template>
        </VSelect>
      </div>
      <div class="w-full" v-if="canEdit('gadget_model')">
        <VSelect
          :items="gadgets"
          label="Modelo"
          id="gadget_model"
          item-text="model"
          item-value="id"
          name="gadget_model"
          v-model="editSale.gadget.id"
          v-validate="'required'"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <div :id="`gadget-model-${index}`" class="v-list__tile__title">{{ item.model }}</div>
            </div>
          </template>
        </VSelect>
      </div>
      <div class="my-2 w-50" v-if="canEdit('model')">
        <VSelect
          :items="gadgetsComputed"
          label="Modelo"
          id="model"
          name="model"
          item-text="model"
          item-value="id"
          v-model="editSale.gadget.id"
          v-validate="'required'"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <div :id="`gadget-${index}`" class="v-list__tile__title">{{ item.model }}</div>
            </div>
          </template>
        </VSelect>
      </div>
      <div class="w-full" v-if="canEdit('offer')">
        <VSelect
          :items="offers"
          label="Oferta"
          id="offer"
          name="offer"
          item-text="name"
          item-value="id"
          v-model="editSale.offer.id"
          v-validate="'required'"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <div :id="`offer-${index}`" class="v-list__tile__title">{{ item.name }}</div>
            </div>
          </template>
        </VSelect>
      </div>
      <div class="my-2 w-50" v-if="canEdit('hdc')">
        <VSelect
          :items="yesOrNo"
          label="Via HDC"
          id="hdc"
          name="hdc"
          v-model="editSale.hdc"
          v-validate="'required'"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <div :id="`hdc-${index}`" class="v-list__tile__title">{{ item.text }}</div>
            </div>
          </template>
        </VSelect>
      </div>
      <div class="my-2 w-50" v-if="canEdit('msisdn')">
        <SmartInput
          label="Número de Telefone"
          id="msisdn"
          name="msisdn"
          :mask="'(##) #####-####'"
          v-model="editSale.msisdn"
          v-validate="'required'"
        />
      </div>
      <div class="my-2 w-50" v-if="canEdit('c6bank')">
        <VSelect
          :items="yesOrNo"
          label="C6 Bank"
          id="c6bank"
          name="c6bank"
          v-model="editSale.c6bank"
          v-validate="'required'"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <div :id="`c6bank-${index}`" class="v-list__tile__title">{{ item.text }}</div>
            </div>
          </template>
        </VSelect>
      </div>
      <div class="my-2 w-50" v-if="canEdit('date')">
        <SmartInput
          type="date-picker"
          label="Data da Venda"
          id="date"
          name="date"
          v-model="editSale.date"
          v-validate="'required'"
        />
      </div>
      <div class="my-2 w-50">
        <SmartInput
          label="Valor"
          id="price"
          name="price"
          v-if="canEdit('price')"
          v-model="editSale.price"
          v-validate="'required'"
        />
      </div>
      <div class="my-2 w-50">
        <SmartInput
          label="ICCID"
          id="iccid"
          name="iccid"
          :mask="'#'.repeat(20)"
          :error="errors.first('iccid')"
          v-if="canEdit('iccid')"
          v-model="editSale.iccid"
          v-validate="'required|length:20'"
        />
      </div>
      <div class="w-50">
        <VSelect
          :items="recarga"
          label="Valor da recarga"
          id="recarga_price"
          name="recarga_price"
          v-if="canEdit('recarga_price')"
          v-model="editSale.price"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <div :id="`recarga-price-${index}`" class="v-list__tile__title">{{ item.name }}</div>
            </div>
          </template>
        </VSelect>
      </div>
      <div class="my-2 w-50">
        <SmartInput
          label="Número de Série"
          id="serialNumber"
          name="serialNumber"
          v-if="canEdit('serialNumber')"
          v-model="editSale.serialNumber"
          v-validate="'required'"
        />
      </div>
    </div>
    <div class="flex py-2  pb-1 justify-end">
      <div class="inline-flex">
        <SmartButton class="mr-2" secondary @click="closeEdit">
          Voltar
        </SmartButton>
      </div>
      <div class="inline-flex">
        <SmartButton class="mr-2" @click="updateWarning">
          Atualizar Venda
        </SmartButton>
        <SmartModal
          v-if="modal"
          v-bind="modal"
          :loadingFirstButton="isLoading"
          @close="modal.action"
          @return="modalType(modal.type)"
        >
          {{ modal.text }}
        </SmartModal>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

const fieldsCanBeEditable = {
  PLANO: [
    'customerCpf',
    'iccid',
    'msisdn',
    'price',
    'hdc',
    'c6bank',
    'socialNetwork',
    'category',
    'date'
  ],
  RECARGA: ['customerCpf', 'msisdn', 'price', 'date'],
  APARELHO: ['customerCpf', 'imei', 'price', 'brand', 'model', 'offer', 'date'],
  ACESSORIO: [
    'customerCpf',
    'serialNumber',
    'price',
    'gadget_category',
    'gadget_model',
    'offer',
    'date'
  ]
};
export default {
  name: 'Edit',
  data() {
    return {
      editSale: {},
      categories: [
        { value: 'PORTABILIDADE', text: 'PORTABILIDADE' },
        { value: 'ATIVACAO', text: 'ATIVACAO' },
        { value: 'MIGRACAO', text: 'MIGRACAO' }
      ],
      yesOrNo: [{ value: 1, text: 'Sim' }, { value: 0, text: 'Não' }],
      recarga: [
        { value: 10, text: 'R$ 10' },
        { value: 15, text: 'R$ 15' },
        { value: 20, text: 'R$ 20' },
        { value: 30, text: 'R$ 30' },
        { value: 40, text: 'R$ 40' },
        { value: 50, text: 'R$ 50' },
        { value: 100, text: 'R$ 100' }
      ],
      isLoading: false,
      modal: null
    };
  },
  props: {
    sale: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      brands: 'brand/brands',
      gadgets: 'gadget/gadgets',
      gadgetCategories: 'gadget/gadgetCategories'
    }),
    gadgetsComputed() {
      if (!this.gadgets || !this.gadgets.length) {
        return [{ ...this.editSale.gadget, model: `${this.editSale.gadget.model} - Desativado` }];
      }

      if (
        this.gadgets &&
        this.gadgets.length &&
        !this.gadgets.find(gadgest => gadgest.id === this.editSale.gadget.id)
      ) {
        return [
          ...this.gadgets,
          { ...this.editSale.gadget, model: `${this.editSale.gadget.model} - Desativado` }
        ];
      }
      return this.gadgets;
    },
    formIsValid() {
      return Object.keys(this.fields).every(field => this.fields[field].valid);
    },
    offers() {
      const gadget = this.gadgets.find(gadgest => gadgest.id === this.editSale.gadget.id);
      let offers;
      if (gadget && !gadget.offers.find(offer => offer.id === this.editSale.offer.id)) {
        const newOffer = {
          ...this.editSale.offer,
          name: `${this.editSale.offer.name} - Desativado  `
        };
        offers = [...gadget.offers, newOffer];
      }
      if (!gadget) {
        offers = [{ ...this.editSale.offer, name: `${this.editSale.offer.name} - Desativado  ` }];
      }
      return !!offers ? offers : gadget && gadget.offers;
    },
    customerCpf() {
      const adaptCpf =
        this.editSale.customerCpf && this.editSale.customerCpf.replace(/[^0-9]/g, '');
      return adaptCpf;
    },
    msisdn() {
      const adaptMsisdn = this.editSale.msisdn && this.editSale.msisdn.replace(/[^0-9]/g, '');
      return adaptMsisdn;
    }
  },
  methods: {
    ...mapActions({
      updateSale: 'saleManagement/updateSale',
      fetchBrand: 'brand/fetchBrand',
      fetchGadget: 'gadget/fetchGadget',
      fetchGadgetCategory: 'gadget/fetchGadgetCategory',
      fetchGadgetByCategory: 'gadget/fetchGadgetByCategory'
    }),
    canEdit(field) {
      return (
        fieldsCanBeEditable[this.editSale.type] &&
        fieldsCanBeEditable[this.editSale.type].includes(field)
      );
    },
    closeEdit() {
      this.editSale = Object.assign({}, this.sale);
      this.$emit('cancel');
    },
    updateWarning() {
      this.modal = {
        type: 'warning',
        title: 'Atualizar Venda',
        icon: 'warning',
        buttonText: 'Sim, atualizar!',
        secondButton: 'Não, cancelar.',
        text: 'Você realmente deseja atualizar esta venda cantada?',
        action: this.submit
      };
    },
    modalType(type) {
      if (type === 'success') {
        this.$emit('reload');
        this.$emit('cancel');
        this.modal = null;
      } else {
        this.modal = null;
      }
    },
    submit() {
      this.isLoading = true;
      const { id } = this.editSale;
      let payload;
      if (this.editSale.gadget) {
        payload = {
          sale_form: {
            customer_cpf: this.customerCpf,
            iccid: this.editSale.iccid,
            msisdn: this.msisdn,
            value: this.editSale.price,
            hdc: this.editSale.hdc,
            c6bank: this.editSale.c6bank,
            social_network: this.editSale.socialNetwork,
            category: this.editSale.category,
            sale_date: this.editSale.date,
            imei: this.editSale.imei,
            gadget_id: this.editSale.gadget.id,
            offer_id: this.editSale.offer.id,
            serial_number: this.editSale.serialNumber
          }
        };
      } else {
        payload = {
          sale_form: {
            customer_cpf: this.customerCpf,
            iccid: this.editSale.iccid,
            msisdn: this.msisdn,
            value: this.editSale.price,
            hdc: this.editSale.hdc,
            c6bank: this.editSale.c6bank,
            social_network: this.editSale.socialNetwork,
            category: this.editSale.category,
            sale_date: this.editSale.date,
            imei: this.editSale.imei
          }
        };
      }
      this.updateSale({ payload, id })
        .then(() => {
          this.isLoading = false;
          this.modal = {
            type: 'success',
            title: 'Venda Atualizada',
            icon: 'accepted',
            secondButton: 'Ok',
            text: 'Venda atualizada com sucesso!',
            action: () => null
          };
        })
        .catch(({ data }) => {
          this.modal = {
            type: 'danger',
            title: 'Ocorreu um Erro',
            icon: 'refused',
            secondButton: 'Tentar Novamente',
            text: data.message,
            action: () => null
          };
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },
  async mounted() {
    this.editSale = JSON.parse(JSON.stringify(this.sale));
    this.editSale.hdc = this.sale.hdc;
    this.editSale.c6bank = this.sale.c6bank;
    this.editSale.date = moment(this.sale.date.replace(/-/g, '/'), 'YYYY-MM-DD hh:mm:ss').format();
    this.editSale.socialNetwork = this.sale.socialNetwork;

    if (this.editSale.type === 'APARELHO') {
      this.fetchBrand();
      await this.fetchGadget(this.editSale.gadget.brand.id);
    }

    if (this.editSale.type === 'ACESSORIO') {
      this.fetchGadgetCategory();
      await this.fetchGadgetByCategory(this.editSale.gadget.gadget_category.id);
    }
  }
};
</script>

<style lang="scss">
.mx-datepicker-popup {
  z-index: 9999999 !important;
}
.w-50 {
  width: 50%;
}
</style>
